import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';
import theme from 'theme';
import { RELATIVE_HEIGHT } from './constants';


const fundEntityListStyles: StylesConfig<OptionType, false> = {
  control: styles => ({
    ...styles,
    height: '3.75rem',
    minHeight: RELATIVE_HEIGHT,
    width: '100%',
    border: 'none',
    borderColor: 'none',
    borderRadius: 'none',
    backgroundColor: 'white',
    position: 'absolute',
    left: 0,
    top: 0,
    boxShadow: 'none',
  }),
  container: () => ({
    position: 'relative',
    width: 'auto',
    minWidth: '100%',
  }),
  valueContainer: styles => ({
    ...styles,
    height: RELATIVE_HEIGHT,
    marginTop: '2px',
    fontWeight: 400,
    padding: '2px 2px 4px',
    width: 'auto',
    minWidth: '100%',
  }),
  singleValue: styles => ({
    ...styles,
    color: theme.palette.primary[700],
    marginRight: 0,
    right: 0,
    top: '47%',
    width: 'auto',
    minWidth: '100%',
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none',
  }),
  indicatorsContainer: styles => ({
    ...styles,
    height: RELATIVE_HEIGHT,
    marginTop: '2px',
    fontWeight: 400,
    padding: 0,
  }),
  option: styles => ({
    ...styles,
    padding: '5px 12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  menu: styles => ({
    ...styles,
    left: 0,
    borderRadius: 'none',
    marginTop: '-4.25rem',
    fontWeight: 400,
    width: 'auto',
    minWidth: '100%',
  }),
  menuList: styles => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    bottom: '100%',
    width: 'auto',
    minWidth: '100%',
  }),
  menuPortal: styles => ({
    ...styles,
    fontSize: 14,
    margin: '-2rem 0 0',
    height: RELATIVE_HEIGHT,
    color: theme.palette.primary[700],
    zIndex: 9999,
  }),
};

export default fundEntityListStyles;
